/**
 * axios 全局配置
 * 包含基础URL设置、请求头配置、响应拦截器（登录过期、权限校验、token自动续期）
 */
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from '@/store';
import router from '@/router';
import setting from './setting';
import { MessageBox } from 'element-ui';

// 注册 VueAxios 插件
Vue.use(VueAxios, axios);

// 设置全局基础URL
axios.defaults.baseURL = setting.baseURL;
// 设置全局请求头 token
axios.defaults.headers.common[setting.tokenHeaderName] = store.state.user.token;
// 设置 POST 请求默认 Content-Type
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

/**
 * 响应拦截器
 * - 成功响应：处理401登录过期、1002无权限、token自动续期
 * - 失败响应：弹窗提示并统一错误处理
 */
axios.interceptors.response.use(
  (res) => {
    // 401 登录过期处理：弹窗提示并跳转登录页
    if (res.data.resCode === 401) {
      MessageBox.alert('登录状态已过期，请退出重新登录！', '系统提示', {
        confirmButtonText: '重新登录',
        callback: (action) => {
          if (action === 'confirm') {
            store.dispatch('user/setToken').then(() => {
              router.push({ path: '/login' });
            });
          }
        },
        beforeClose: () => {
          MessageBox.close();
        },
      });
      return Promise.reject(new Error(res.data.resMsg));
    }
    // 1002 无操作权限处理
    if (res.data.resCode === 1002) {
      MessageBox.alert('当前无操作权限，请联系管理员进行核实！');
      return Promise.reject(new Error(res.data.resMsg));
    }
    // token 自动续期：从响应头中获取新token并更新
    let access_token = res.headers[setting.tokenReponseName];
    if (access_token) store.dispatch('user/setToken', access_token);
    return res;
  },
  (error) => {
    MessageBox.alert(error.message, '系统提示');
    return Promise.reject(error);
  }
);

export default axios;
